/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'
import { candidateFileDataAttributeSchema } from './CandidateFileDataAttributeSchema'
import { candidateFileDataScanStatusSchema } from './CandidateFileDataScanStatusSchema'

export const candidateFileDataSchema = z.object({
	id: z.string(),
	candidateId: z.string(),
	name: z.string(),
	fileName: z.string(),
	mimeType: z.string().nullable(),
	size: z.number(),
	url: z.string().nullable(),
	previewUrl: z.string().nullable(),
	createdAt: z.iso.datetime(),
	metadata: z.object({ sourceEmailId: z.string().nullable(), sourceEmailSubject: z.string().nullable() }).nullable(),
	scanStatus: candidateFileDataScanStatusSchema.nullable(),
	scanSignature: z.string().nullable(),
	attribute: candidateFileDataAttributeSchema.nullable(),
})

export type CandidateFileDataSchema = z.infer<typeof candidateFileDataSchema>
